import { FirebaseApp, initializeApp } from 'firebase/app'
import {
  Database,
  getDatabase,
  off,
  onChildAdded,
  onChildChanged,
  onValue,
  ref,
  DatabaseReference
} from 'firebase/database'

import { LiveStatusChangedCallback, TriggerCallback, LivePlaybackStatusChangedCallback } from './types'

import { LiveStatus, PlaybackStatus } from 'modules/transmission/types'

const firebaseConfig = {
  apiKey: process.env.LIVE_FIREBASE_API_KEY,
  authDomain: process.env.LIVE_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.LIVE_FIREBASE_DATABASE_URL,
  projectId: process.env.LIVE_FIREBASE_PROJECT_ID,
  storageBucket: process.env.LIVE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.LIVE_FIREBASE_MESSAGING_SENDER_IR,
  appId: process.env.LIVE_FIREBASE_APP_ID
}

// TODO: Separar esse codigo em uma lib para ser usada no app-live-admin, app-live-user e app-live-chat

class FirebaseService {
  app: FirebaseApp
  database: Database

  constructor() {
    this.app = initializeApp(firebaseConfig)
    this.database = getDatabase(this.app)
  }

  addChangedLiveStatusListener(liveCode: string, callback: LiveStatusChangedCallback) {
    const statusRef = ref(this.database, `live/${liveCode}`)

    onValue(statusRef, snapshot => {
      const status = snapshot.val() as LiveStatus

      callback(status)
    })

    return statusRef
  }

  addChangedLivePlaybackStatusListener(liveCode: string, callback: LivePlaybackStatusChangedCallback) {
    const playbackStatusRef = ref(this.database, `live/${liveCode}/playbackStatus`)

    onValue(playbackStatusRef, snapshot => {
      const status = snapshot.val() as PlaybackStatus

      callback(status)
    })

    return playbackStatusRef
  }

  addTriggerListener(liveCode: string, callback: TriggerCallback) {
    const triggerRef = ref(this.database, `live/${liveCode}/trigger`)

    onChildAdded(triggerRef, data => {
      const triggerId = data.key as string
      const isActive = data.val().active as boolean

      callback(triggerId, isActive)
    })

    onChildChanged(triggerRef, data => {
      const triggerId = data.key as string
      const isActive = data.val().active as boolean

      callback(triggerId, isActive)
    })

    return triggerRef
  }

  removeListener(ref: DatabaseReference) {
    off(ref)
  }
}

export default FirebaseService
